export default function insertErrorMessage (locationMessage, errorMessage) {
  let message = document.createElement('span')
  message.classList.add('error')
  message.innerHTML = errorMessage
  locationMessage.parentNode.insertBefore(message, locationMessage.nextSibling)
}
